import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import AddQueueRelationRequest from '../../../projects/task/i-service/models/task/request/AddQueueRelationRequest';
import RemoveQueueRelationRequest from '../../../projects/task/i-service/models/task/request/RemoveQueueRelationRequest';
import TaskUpdateDescriptionRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateDescriptionRequest';
import TaskUpdateNameRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateNameRequest';
import TaskUpdatePriorityRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdatePriorityRequest';
import UpdateDifficultyRequest from '../../../projects/task/i-service/models/task/request/UpdateDifficultyRequest';
import TaskUpdateStatusRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateStatusRequest';
import UpdateTaskTypeRequest from '../../../projects/task/i-service/models/task/request/UpdateTaskTypeRequest';
import TaskUpdateDateEndRequest from '../../../projects/task/i-service/models/task/request/edit/TaskUpdateDateEndRequest';
import TaskMoveRequest from '../../../projects/task/i-service/models/task/request/TaskMoveRequest';
import TaskCreateRequest from '../../../projects/task/i-service/models/task/request/TaskCreateRequest';
import TaskRemoveRequest from '../../../projects/task/i-service/models/task/request/TaskRemoveRequest';
import PerformersUpdateRequest from '../../../projects/task/i-service/models/task/request/PerformersUpdateRequest';
import ObserverUpdateRequest from '../../../projects/task/i-service/models/observer/request/ObserverUpdateRequest';
import AddTagsRequest from '../../../projects/task/i-service/models/tag/request/AddTagsRequest';
import UpsertFinalEstimateRequest from '../../../projects/task/i-service/models/task/response/UpsertFinalEstimateRequest';
import EstimatePerformerSaveRequest from '../../../projects/task/i-service/models/task/request/EstimatePerformerSaveRequest';
import RemoveEstimatePerformerRequest from '../../../projects/task/i-service/models/task/request/RemoveEstimatePerformerRequest';
import UpdateFileNameRequest from '../../../projects/task/i-service/models/task/request/file/UpdateFileNameRequest';
import RemoveFilesTaskRequest from '../../../projects/task/i-service/models/task/request/file/RemoveFilesTaskRequest';
import RemoveSubtaskRequest from '../../../projects/task/i-service/models/task/request/RemoveSubtaskRequest';
import AttachSubtaskRequest from '../../../projects/task/i-service/models/task/request/AttachSubtaskRequest';
import SubscribeToQueueTasksRequest from '../../../projects/task/i-service/models/task/request/SubscribeToQueueTasksRequest';
import UnSubscribeFromQueueTasksRequest from '../../../projects/task/i-service/models/task/request/UnSubscribeFromQueueTasksRequest';
import SubscribeToDetailTaskRequest from '../../../projects/task/i-service/models/task/request/SubscribeToDetailTaskRequest';
import SubscribeToDetailTaskListRequest from '../../../projects/task/i-service/models/task/request/SubscribeToDetailTaskListRequest';
import UnSubscribeToDetailTaskRequest from '../../../projects/task/i-service/models/task/request/UnSubscribeToDetailTaskRequest';
import UnSubscribeToDetailTaskListRequest from '../../../projects/task/i-service/models/task/request/UnSubscribeToDetailTaskListRequest';
import TaskMoveQueueRequest from '../../../projects/task/i-service/models/task/request/TaskMoveQueueRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import TaskCreateResponse from '../../../projects/task/i-service/models/task/response/TaskCreateResponse';
import UpdateFileNameResponse from '../../../projects/task/i-service/models/task/response/UpdateFileNameResponse';
import TaskShortInfo from '../../../projects/task/i-service/models/TaskShortInfo';
import CreateTaskResponseEvent from '../../../projects/task/i-service/models/task/response/event/CreateTaskResponseEvent';
import UpdateDescriptionResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateDescriptionResponseEvent';
import UpdateNameResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateNameResponseEvent';
import UpdatePriorityResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdatePriorityResponseEvent';
import UpdateStatusResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateStatusResponseEvent';
import UpdateDateEndResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateDateEndResponseEvent';
import UpdateSprintResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateSprintResponseEvent';
import UpdatePerformersResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdatePerformersResponseEvent';
import UpdateObserverResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateObserverResponseEvent';
import UpdateTagsInTaskResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateTagsInTaskResponseEvent';
import UpdateDifficultyResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateDifficultyResponseEvent';
import RemoveFilesResponseEvent from '../../../projects/task/i-service/models/task/response/event/RemoveFilesResponseEvent';
import AddFileResponseEvent from '../../../projects/task/i-service/models/task/response/event/AddFileResponseEvent';
import RemoveTaskResponseEvent from '../../../projects/task/i-service/models/task/response/event/RemoveTaskResponseEvent';
import UpdateTaskTypeResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateTaskTypeResponseEvent';
import RemoveSubtaskResponseEvent from '../../../projects/task/i-service/models/task/response/event/RemoveSubtaskResponseEvent';
import AttachSubtaskForParentResponseEvent from '../../../projects/task/i-service/models/task/response/event/AttachSubtaskForParentResponseEvent';
import RemoveEstimatePerformerResponseEvent from '../../../projects/task/i-service/models/task/response/event/RemoveEstimatePerformerResponseEvent';
import UpdateFileNameResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpdateFileNameResponseEvent';
import AddFilesBatchResponseEvent from '../../../projects/task/i-service/models/task/response/event/AddFilesBatchResponseEvent';
import RemoveQueueRelationResponseEvent from '../../../projects/task/i-service/models/task/response/event/RemoveQueueRelationResponseEvent';
import AddQueueRelationResponseEvent from '../../../projects/task/i-service/models/task/response/event/AddQueueRelationResponseEvent';
import OnAddOrRemovePerformerToTaskInProjectResponse from '../../../projects/task/i-service/models/task/response/OnAddOrRemovePerformerToTaskInProjectResponse';
import ChangeOrderNumberQueueTaskResponseEvent from '../../../projects/task/i-service/models/task/response/event/ChangeOrderNumberQueueTaskResponseEvent';
import UpsertFinalEstimateResponseEvent from '../../../projects/task/i-service/models/task/response/event/UpsertFinalEstimateResponseEvent';

/**
 * * Сервис для редактирования задачи
 */
export default class ProjectTaskSaveService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Событие на создание задачи
	 */
	OnCreateTaskEventEvent = new Events<WsResponseModelT<CreateTaskResponseEvent>>();
	/**
	 * * Событие на обновление описание задачи
	 */
	OnUpdateTaskDescriptionEventEvent = new Events<WsResponseModelT<UpdateDescriptionResponseEvent>>();
	/**
	 * * Событие на обновление названия задачи
	 */
	OnUpdateTaskNameEventEvent = new Events<WsResponseModelT<UpdateNameResponseEvent>>();
	/**
	 * * Событие на обновление приоритета задачи
	 */
	OnUpdateTaskPriorityEventEvent = new Events<WsResponseModelT<UpdatePriorityResponseEvent>>();
	/**
	 * * Событие на обновление статуса задачи
	 */
	OnUpdateTaskStatusEventEvent = new Events<WsResponseModelT<UpdateStatusResponseEvent>>();
	/**
	 * * Событие на обновление дэдлайна задачи
	 */
	OnUpdateTaskDateEndEventEvent = new Events<WsResponseModelT<UpdateDateEndResponseEvent>>();
	/**
	 * * Событие на обновление спринта задачи
	 */
	OnUpdateTaskSprintEventEvent = new Events<WsResponseModelT<UpdateSprintResponseEvent>>();
	/**
	 * * Событие на обновление исполнителей задачи
	 */
	OnUpdateTaskPerformersEventEvent = new Events<WsResponseModelT<UpdatePerformersResponseEvent>>();
	/**
	 * * Событие на обновление наблюдателей задачи
	 */
	OnUpdateTaskObserverEventEvent = new Events<WsResponseModelT<UpdateObserverResponseEvent>>();
	/**
	 * * Событие на обновление тегов в задаче
	 */
	OnUpdateTagsInTaskEventEvent = new Events<WsResponseModelT<UpdateTagsInTaskResponseEvent>>();
	/**
	 * * Событие на обновление сложности в задаче
	 */
	OnUpdateTaskDifficultyEventEvent = new Events<WsResponseModelT<UpdateDifficultyResponseEvent>>();
	/**
	 * * Событие на удаление файлов в задаче
	 */
	OnRemoveTaskFilesEventEvent = new Events<WsResponseModelT<RemoveFilesResponseEvent>>();
	/**
	 * * Событие на добавление файла в задачу
	 */
	OnAddTaskFileEventEvent = new Events<WsResponseModelT<AddFileResponseEvent>>();
	/**
	 * * Событие на удаление задачи
	 */
	OnRemoveTaskEventEvent = new Events<WsResponseModelT<RemoveTaskResponseEvent>>();
	/**
	 * * Событие на обновление типа задачи
	 */
	OnUpdateTaskTypeEventEvent = new Events<WsResponseModelT<UpdateTaskTypeResponseEvent>>();
	/**
	 * * Событие на удаление подзадачи в задаче
	 */
	OnRemoveTaskSubtaskEventEvent = new Events<WsResponseModelT<RemoveSubtaskResponseEvent>>();
	/**
	 * * Событие на добавление подзадачи к задаче для родителя
	 */
	OnAttachTaskForParentSubtaskEventEvent = new Events<WsResponseModelT<AttachSubtaskForParentResponseEvent>>();
	/**
	 * * Событие на удаление оценки времени задачи
	 */
	OnRemoveTaskEstimatePerformerEventEvent = new Events<WsResponseModelT<RemoveEstimatePerformerResponseEvent>>();
	/**
	 * * Событие на обновление названии файла к задаче
	 */
	OnUpdateTaskFileNameEventEvent = new Events<WsResponseModelT<UpdateFileNameResponseEvent>>();
	/**
	 * * Событие на добавление файлы пачками задачи
	 */
	OnAddTaskFilesBatchEventEvent = new Events<WsResponseModelT<AddFilesBatchResponseEvent>>();
	/**
	 * * Событие на обновление описание задачи
	 */
	OnRemoveTaskQueueRelationEventEvent = new Events<WsResponseModelT<RemoveQueueRelationResponseEvent>>();
	/**
	 * * Событие на обновление описание задачи
	 */
	OnAddTaskQueueRelationEventEvent = new Events<WsResponseModelT<AddQueueRelationResponseEvent>>();
	/**
	 * * Событие на добавление/удаление исполнителя в задаче проекта
	 */
	OnAddOrRemovePerformerToTaskInProjectEvent = new Events<WsResponseModelT<OnAddOrRemovePerformerToTaskInProjectResponse>>();
	/**
	 * * Событие на измение номера приоритета задачи в очереди
	 */
	OnChangeOrderNumberQueueTaskEventEvent = new Events<WsResponseModelT<ChangeOrderNumberQueueTaskResponseEvent>>();
	/**
	 * * Событие на добавление финальной оценки времени задачи
	 */
	OnUpsertFinalEstimateTaskEventEvent = new Events<WsResponseModelT<UpsertFinalEstimateResponseEvent>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectTaskSaveService', 'OnCreateTaskEvent', 'Main', (res: WsResponseModelT<CreateTaskResponseEvent>) => {
			self.OnCreateTaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskDescriptionEvent', 'Main', (res: WsResponseModelT<UpdateDescriptionResponseEvent>) => {
			self.OnUpdateTaskDescriptionEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskNameEvent', 'Main', (res: WsResponseModelT<UpdateNameResponseEvent>) => {
			self.OnUpdateTaskNameEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskPriorityEvent', 'Main', (res: WsResponseModelT<UpdatePriorityResponseEvent>) => {
			self.OnUpdateTaskPriorityEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskStatusEvent', 'Main', (res: WsResponseModelT<UpdateStatusResponseEvent>) => {
			self.OnUpdateTaskStatusEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskDateEndEvent', 'Main', (res: WsResponseModelT<UpdateDateEndResponseEvent>) => {
			self.OnUpdateTaskDateEndEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskSprintEvent', 'Main', (res: WsResponseModelT<UpdateSprintResponseEvent>) => {
			self.OnUpdateTaskSprintEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskPerformersEvent', 'Main', (res: WsResponseModelT<UpdatePerformersResponseEvent>) => {
			self.OnUpdateTaskPerformersEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskObserverEvent', 'Main', (res: WsResponseModelT<UpdateObserverResponseEvent>) => {
			self.OnUpdateTaskObserverEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTagsInTaskEvent', 'Main', (res: WsResponseModelT<UpdateTagsInTaskResponseEvent>) => {
			self.OnUpdateTagsInTaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskDifficultyEvent', 'Main', (res: WsResponseModelT<UpdateDifficultyResponseEvent>) => {
			self.OnUpdateTaskDifficultyEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnRemoveTaskFilesEvent', 'Main', (res: WsResponseModelT<RemoveFilesResponseEvent>) => {
			self.OnRemoveTaskFilesEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnAddTaskFileEvent', 'Main', (res: WsResponseModelT<AddFileResponseEvent>) => {
			self.OnAddTaskFileEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnRemoveTaskEvent', 'Main', (res: WsResponseModelT<RemoveTaskResponseEvent>) => {
			self.OnRemoveTaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskTypeEvent', 'Main', (res: WsResponseModelT<UpdateTaskTypeResponseEvent>) => {
			self.OnUpdateTaskTypeEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnRemoveTaskSubtaskEvent', 'Main', (res: WsResponseModelT<RemoveSubtaskResponseEvent>) => {
			self.OnRemoveTaskSubtaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnAttachTaskForParentSubtaskEvent', 'Main', (res: WsResponseModelT<AttachSubtaskForParentResponseEvent>) => {
			self.OnAttachTaskForParentSubtaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnRemoveTaskEstimatePerformerEvent', 'Main', (res: WsResponseModelT<RemoveEstimatePerformerResponseEvent>) => {
			self.OnRemoveTaskEstimatePerformerEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpdateTaskFileNameEvent', 'Main', (res: WsResponseModelT<UpdateFileNameResponseEvent>) => {
			self.OnUpdateTaskFileNameEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnAddTaskFilesBatchEvent', 'Main', (res: WsResponseModelT<AddFilesBatchResponseEvent>) => {
			self.OnAddTaskFilesBatchEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnRemoveTaskQueueRelationEvent', 'Main', (res: WsResponseModelT<RemoveQueueRelationResponseEvent>) => {
			self.OnRemoveTaskQueueRelationEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnAddTaskQueueRelationEvent', 'Main', (res: WsResponseModelT<AddQueueRelationResponseEvent>) => {
			self.OnAddTaskQueueRelationEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnAddOrRemovePerformerToTaskInProject', 'Main', (res: WsResponseModelT<OnAddOrRemovePerformerToTaskInProjectResponse>) => {
			self.OnAddOrRemovePerformerToTaskInProjectEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnChangeOrderNumberQueueTaskEvent', 'Main', (res: WsResponseModelT<ChangeOrderNumberQueueTaskResponseEvent>) => {
			self.OnChangeOrderNumberQueueTaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectTaskSaveService', 'OnUpsertFinalEstimateTaskEvent', 'Main', (res: WsResponseModelT<UpsertFinalEstimateResponseEvent>) => {
			self.OnUpsertFinalEstimateTaskEventEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Добавление связей очередей в задаче
	 */
	async AddQueueRelation(request: AddQueueRelationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'AddQueueRelation',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление связи очреди в задаче
	 */
	async RemoveQueueRelation(request: RemoveQueueRelationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'RemoveQueueRelation',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить описание
	 */
	async UpdateDescription(query: TaskUpdateDescriptionRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateDescription',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить название задачи
	 */
	async UpdateName(query: TaskUpdateNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateName',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить приоритет
	 */
	async UpdatePriority(query: TaskUpdatePriorityRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdatePriority',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление сложности задачи
	 */
	async UpdateDifficulty(request: UpdateDifficultyRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateDifficulty',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить статус
	 */
	async UpdateStatus(query: TaskUpdateStatusRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateStatus',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Метод обновления типа задачи
	 */
	async UpdateTaskType(request: UpdateTaskTypeRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateTaskType',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поменять дату конца
	 */
	async UpdateDateEnd(request: TaskUpdateDateEndRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateDateEnd',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Перенос задачи
	 */
	async TaskMove(request: TaskMoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'TaskMove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создать задачу
	 */
	async TaskCreate(query: TaskCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'TaskCreate',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление
	 */
	async Remove(request: TaskRemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'Remove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить исполнителей
	 */
	async UpdatePerformers(request: PerformersUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdatePerformers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение наблюдателей к задаче
	 */
	async UpdateObserver(request: ObserverUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateObserver',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление тегов задачи
	 */
	async UpdateTagsInTask(request: AddTagsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateTagsInTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Выставление финальной оценки времени
	 */
	async UpsertFinalEstimate(request: UpsertFinalEstimateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpsertFinalEstimate',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить оценку времени
	 */
	async UpsertEstimatePerformer(request: EstimatePerformerSaveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpsertEstimatePerformer',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить оценку исполнителя
	 */
	async RemoveEstimatePerformer(request: RemoveEstimatePerformerRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'RemoveEstimatePerformer',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение названия файла
	 */
	async UpdateFileName(request: UpdateFileNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UpdateFileName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async RemoveFiles(request: RemoveFilesTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'RemoveFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Убирает подзадачу из задачи
	 */
	async RemoveSubtask(query: RemoveSubtaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'RemoveSubtask',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление подзадачи
            Подзадачу нельзя добавить если она не найдена, если у нее уже есть родитель, если новый родитель имеет родителя, если номер задачи равен номеру родителя и если задача уже является чьим-либо родителем
	 */
	async AttachSubtask(query: AttachSubtaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'AttachSubtask',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Подключение к комнате очереди задачи
	 */
	async SubscribeToQueueTasks(request: SubscribeToQueueTasksRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'SubscribeToQueueTasks',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отключение от комнаты очереди задачи
	 */
	async UnSubscribeFromQueueTasks(request: UnSubscribeFromQueueTasksRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UnSubscribeFromQueueTasks',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Подключение к комнате детальной странице задачи
	 */
	async SubscribeToDetailTask(request: SubscribeToDetailTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'SubscribeToDetailTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Подписка на события списка задач
	 */
	async SubscribeToDetailTaskList(request: SubscribeToDetailTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'SubscribeToDetailTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отключение от комнаты детальной страницы задачи
	 */
	async UnSubscribeToDetailTask(request: UnSubscribeToDetailTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UnSubscribeToDetailTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отписка от списка задач
	 */
	async UnSubscribeToDetailTaskList(request: UnSubscribeToDetailTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'UnSubscribeToDetailTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Метод для переноса задачи в очереди
	 */
	async TaskMoveInQueue(request: TaskMoveQueueRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskSaveService',
			Method: 'TaskMoveInQueue',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Добавление связей очередей в задаче
	 */
	async addQueueRelationAsync(request: AddQueueRelationRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'AddQueueRelation',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление связи очреди в задаче
	 */
	async removeQueueRelationAsync(request: RemoveQueueRelationRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'RemoveQueueRelation',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить описание
	 */
	async updateDescriptionAsync(query: TaskUpdateDescriptionRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateDescription',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить название задачи
	 */
	async updateNameAsync(query: TaskUpdateNameRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateName',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить приоритет
	 */
	async updatePriorityAsync(query: TaskUpdatePriorityRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdatePriority',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление сложности задачи
	 */
	async updateDifficultyAsync(request: UpdateDifficultyRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateDifficulty',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить статус
	 */
	async updateStatusAsync(query: TaskUpdateStatusRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateStatus',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Метод обновления типа задачи
	 */
	async updateTaskTypeAsync(request: UpdateTaskTypeRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateTaskType',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поменять дату конца
	 */
	async updateDateEndAsync(request: TaskUpdateDateEndRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateDateEnd',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Перенос задачи
	 */
	async taskMoveAsync(request: TaskMoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'TaskMove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создать задачу
	 */
	async taskCreateAsync(query: TaskCreateRequest): Promise<TaskCreateResponse> {
		return new Promise<TaskCreateResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'TaskCreate',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<TaskCreateResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskCreateResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление
	 */
	async removeAsync(request: TaskRemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'Remove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить исполнителей
	 */
	async updatePerformersAsync(request: PerformersUpdateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdatePerformers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение наблюдателей к задаче
	 */
	async updateObserverAsync(request: ObserverUpdateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateObserver',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление тегов задачи
	 */
	async updateTagsInTaskAsync(request: AddTagsRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateTagsInTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Выставление финальной оценки времени
	 */
	async upsertFinalEstimateAsync(request: UpsertFinalEstimateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpsertFinalEstimate',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить оценку времени
	 */
	async upsertEstimatePerformerAsync(request: EstimatePerformerSaveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpsertEstimatePerformer',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить оценку исполнителя
	 */
	async removeEstimatePerformerAsync(request: RemoveEstimatePerformerRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'RemoveEstimatePerformer',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение названия файла
	 */
	async updateFileNameAsync(request: UpdateFileNameRequest): Promise<UpdateFileNameResponse> {
		return new Promise<UpdateFileNameResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UpdateFileName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UpdateFileNameResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UpdateFileNameResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async removeFilesAsync(request: RemoveFilesTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'RemoveFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Убирает подзадачу из задачи
	 */
	async removeSubtaskAsync(query: RemoveSubtaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'RemoveSubtask',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление подзадачи
            Подзадачу нельзя добавить если она не найдена, если у нее уже есть родитель, если новый родитель имеет родителя, если номер задачи равен номеру родителя и если задача уже является чьим-либо родителем
	 */
	async attachSubtaskAsync(query: AttachSubtaskRequest): Promise<TaskShortInfo> {
		return new Promise<TaskShortInfo>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'AttachSubtask',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<TaskShortInfo>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskShortInfo)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Подключение к комнате очереди задачи
	 */
	async subscribeToQueueTasksAsync(request: SubscribeToQueueTasksRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'SubscribeToQueueTasks',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отключение от комнаты очереди задачи
	 */
	async unSubscribeFromQueueTasksAsync(request: UnSubscribeFromQueueTasksRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UnSubscribeFromQueueTasks',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Подключение к комнате детальной странице задачи
	 */
	async subscribeToDetailTaskAsync(request: SubscribeToDetailTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'SubscribeToDetailTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Подписка на события списка задач
	 */
	async subscribeToDetailTaskListAsync(request: SubscribeToDetailTaskListRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'SubscribeToDetailTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отключение от комнаты детальной страницы задачи
	 */
	async unSubscribeToDetailTaskAsync(request: UnSubscribeToDetailTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UnSubscribeToDetailTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отписка от списка задач
	 */
	async unSubscribeToDetailTaskListAsync(request: UnSubscribeToDetailTaskListRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'UnSubscribeToDetailTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Метод для переноса задачи в очереди
	 */
	async taskMoveInQueueAsync(request: TaskMoveQueueRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskSaveService',
				Method: 'TaskMoveInQueue',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}